import styled, { keyframes } from '@xstyled/styled-components';
/* Soft green ring pulse — Figma Accept uses rgba(103,206,103,0.2), no blue */
const pulseGreen = keyframes`
  0% {
    box-shadow: 0 0 0 0px rgba(103, 206, 103, 0.35);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(103, 206, 103, 0.15);
  }
  100% {
    box-shadow: 0 0 0 0px rgba(103, 206, 103, 0.35);
  }
`;
import PhoneImage from './iPhone.png';
import phoneBg from './phone-bg.png';
import btnAccept from './btn-accept.png';
import btnDecline from './btn-decline.png';
import {
  PHONE_FRAME_HEIGHT_PX,
  PHONE_FRAME_WIDTH_PX
} from './phoneReflowLayout';

export const PhoneBackground = styled.div`
  background-image: url(${PhoneImage});
  position: absolute;
  width: 300px;
  height: 580px;
  z-index: 1;
`;

export const WrapperForChildren = styled.div`
  div:first-child {
    position: relative;
    height: 285px;
    width: 254px;
    height: 547px;
    top: 0;
    left: 0px;
    z-index: 1;
    border-radius: 10px;
  }
  div:nth-child(2) {
    div:nth-child(1) {
      display: none;
    }
  }
`;

/** Figma Phone (790:18470): frame 248×503.446, screen inset 9.94 / 8.52 */
export const Phone = styled.div`
  background: url(${phoneBg}) no-repeat 50% 50% / contain;
  position: relative;
  width: ${PHONE_FRAME_WIDTH_PX}px;
  height: ${PHONE_FRAME_HEIGHT_PX}px;
`;

/** Figma Contact: left 20.99+9.94, top 54.33+8.52 inside frame */
export const Contact = styled.div`
  position: absolute;
  left: 31px;
  top: 63px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

/** Figma name: SF Pro Text Regular 18.994px */
export const UserName = styled.div`
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 19px;
  font-weight: 400;
  line-height: normal;
  color: #fff;
`;

/** Figma Decline 43.808×43.924 at screen (28, 369.51) → frame (38, 378) */
export const DeclineButton = styled.div`
  background: url(${btnDecline}) no-repeat 50% 50% / contain;
  position: absolute;
  top: 378px;
  left: 38px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  pointer-events: none;
`;

/** Accept button + tooltip anchor (Figma Accept at 160, 378) */
export const CallButtonWrap = styled.div`
  position: absolute;
  top: 378px;
  left: 160px;
  width: 44px;
  height: 44px;
  z-index: 2;
`;

/** Accept — our btn-accept */
export const CallButton = styled.button`
  background: url(${btnAccept}) no-repeat 50% 50% / cover;
  position: absolute;
  inset: 0;
  width: 44px;
  height: 44px;
  border: none;
  outline: none;
  border-radius: 50%;
  transition: box-shadow ease-in-out 0.3s;
  animation: ${pulseGreen} 2.2s infinite;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid var(--color-focus-ring);
    outline-offset: 2px;
  }
`;

/**
 * CAT Tooltip — Figma 186:3742 (light) / 186:3753 (dark).
 * Arrow points down toward Accept.
 * `$counterScale` keeps tooltip at desktop size when the phone is scaled for mobile.
 */
export const AcceptCallTooltip = styled.div<{
  $isDark: boolean;
  $counterScale?: number;
}>`
  position: absolute;
  left: 50%;
  bottom: calc(100% + 10px);
  transform: translateX(-50%)
    ${p =>
      p.$counterScale && p.$counterScale !== 1
        ? `scale(${p.$counterScale})`
        : ''};
  transform-origin: bottom center;
  box-sizing: border-box;
  padding: 4px 12px;
  border-radius: 4px;
  background: ${p => (p.$isDark ? '#464646' : '#ffffff')};
  color: ${p => (p.$isDark ? '#ffffff' : '#2e2e2e')};
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: center;
  white-space: nowrap;
  pointer-events: none;
  box-shadow:
    0px 4px 8px rgba(0, 0, 0, 0.16),
    0px -2px 4px rgba(0, 0, 0, 0.05);

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -6px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid ${p => (p.$isDark ? '#464646' : '#ffffff')};
  }
`;
